export class ManufacturingOrderFeature {
  constructor(
    public hash?: string,
    public name?: string
  ) { }

  clone() {
    return new ManufacturingOrderFeature (
      this.hash,
      this.name
    );
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/manufacturing-order-feature.ts